import { TokenSource } from 'livekit-client'
import {
  CreateAiVoiceSessionTokenDocument,
} from 'generated/resources/graphql'
import { handleResult } from 'modules/core/lib/handleMutation'
import { useMutation } from 'modules/core/hooks/useMutation'

export function useVoiceSessionTokenSource(participantAttributes: Record<string, unknown>) {
  const [mutate] = useMutation(CreateAiVoiceSessionTokenDocument, {
    extractorFn(data) {
      return data.aiVoiceMutations.createAivoiceSessionToken
    },
  })

  async function getToken() {
    const variables = {
      participantAttributes: JSON.stringify(participantAttributes),
    }
    const result = await mutate({ variables })
    const handled = handleResult(result, () => {})
    if (!handled.success) {
      throw new Error('Failed to fetch token')
    }
    const { sessionToken } = handled.data
    if (!sessionToken) {
      throw new Error('No session token')
    }
    return { serverUrl: sessionToken.serverUrl, participantToken: sessionToken.token }
  }

  return TokenSource.literal(getToken)
}
